module.exports = __webpack_public_path__ + "static/big-bad-dff274a50e300eef48730c27abefb34b.jpg";